import {useContext, useMemo} from "react";
import {getQueries} from "../utils/SchoolBlocksUtilities";
import {StoreContext} from "../stores/StoreLoader";
import {GridTypes} from "../pages/MainGridPage";

export const useGridType = (): "terraced" | "packery" => {
    const {interfaceStore, organizationStore} = useContext(StoreContext);

    return useMemo(() => {
        const queries = getQueries(interfaceStore.currentFullUrl || "");
        if (queries.gridType && GridTypes[queries.gridType]) {
            return GridTypes[queries.gridType]
        }
        return !!organizationStore.currentOrganization.json_data?.terracedGrid?.enabled ? GridTypes.terraced : GridTypes.packery;
    }, [interfaceStore.currentFullUrl, organizationStore.currentOrganization?.json_data?.terracedGrid?.enabled])
}